/**
 * @module modules/common/commit
 * @description Commit utility functions.
 *
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TrimHash", {
    enumerable: true,
    get: function() {
        return TrimHash;
    }
});
const TrimHash = (hash)=>{
    return hash.substring(0, 9);
};
